var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('DataTable',{attrs:{"datatable":_vm.table,"on-success":_vm.successAction,"itemsAction":_vm.tableAction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }